import { Injectable, inject } from '@angular/core';
import AngularHelperService from '../services/angular-helper.service';
import AngularMaterialHelperService from '../services/angular-material-helper.service';

@Injectable({ providedIn: 'root' })
export default class ModalService {
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularMaterialHelperService: AngularMaterialHelperService = inject(AngularMaterialHelperService);

	modals: any = {};
	store: any = {};
	ZINDEX_DEFAULT: any = 1100;
	
	close(id) {
		if (!this.modals[id]) return;
		if (this.modals[id].close) this.modals[id].close();
	}
	
	cleanUp(id) {
		if (!this.modals[id]) return;
		delete this.modals[id];
	}
	
	closeAll() {
		var ids: any = Object.keys(this.modals);
		if (!ids.length) return;
		ids.forEach((id) => {
			this.close(id);
		});
	}
	
	get(id) {
		if (!id) return;
		return this.modals[id];
	}
	
	openMedia(ctrl, locals) {
		locals = locals || {};
		locals.noScroll = true;
		
		var opts: any = {
			clickOutsideToClose: false,
			disableParentScroll: false,
			hasBackdrop: false
		};
		
		return this.open(ctrl, locals, opts);
	}
	
	open(ctrl, locals, opts) {
		locals = locals || {};
		locals.modalId = locals.modalId || Math.random().toString(36).replace(/[^a-zA-Z]+/g, '');

		var config: any = opts || {};
		config.data = locals;
		config.attachTo = document.body;
		config.zIndex = this.ZINDEX_DEFAULT;
		config.width = "400px";
		config.height = "auto";
		config.disableScroll = true;

		var modal = this.angularMaterialHelperService.getMaterialPanel().open(ctrl, config);
		
		this.modals[locals.modalId] = modal;
		this.setOnTop(locals.modalId);
	}
	
	setOnTop(id) {
		if (this.store.onTop === id) return;
		this.angularHelperService.forEach(this.modals, (modal, index) => {
			var zIndex: any = index === id ? this.ZINDEX_DEFAULT + 5 : this.ZINDEX_DEFAULT;
			// modal.panelContainer[0].style.zIndex = zIndex;
			// TODO ANGULAR_2: is this needed? can you open more than 1 modal somehow?
		});
		this.store.onTop = id;
	}
	
}